const en = {
  title: 'Stock Management',
  subtitle: 'Monitor and manage inventory levels',
  adjustStockButton: 'Adjust Stock',
  addStockButton: '+ Add Stock',
  totalMovements: 'Total Movements',
  stockIn: 'Stock In',
  stockOut: 'Stock Out',
  lowStock: 'Low Stock',
  outOfStock: 'Out of Stock',
  movementsTab: 'Movements ({{count}})',
  stockLevelsTab: 'Stock Levels ({{count}})',
  lowStockAlertsTab: 'Low Stock Alerts',
  searching: 'Searching: "{{term}}"',
  supplier: 'Supplier:',
  allStatus: 'All Status',
  inStock: 'In Stock',
  clear: 'Clear',
  noMovementsTitle: 'No Stock Movements',
  noMovementsMessage: 'Movements will appear here as you manage inventory',
  part: 'Part',
  type: 'Type',
  qty: 'Qty',
  currentStock: 'Current stock',
  daysUntilEmpty: 'Days until empty',
  reference: 'Reference',
  supplierHeader: 'Supplier',
  user: 'User',
  noStockLevelsTitle: 'No Stock Levels',
  noStockLevelsMessage: 'Add parts to see stock levels',
  orderNumber: 'Open Order',
  quantity: 'Quantity',
  minLevel: 'Min Level',
  restockingNotes: 'Restocking {{name}}',
  add: 'Add',
  adjust: 'Adjust',
  noAlertsTitle: 'No Low Stock Alerts',
  noAlertsMessage: 'All items are well stocked',
  current: 'Current',
  orderNr: 'Open Order',
  daysUntilEmptyHeader: 'Days Until Empty',
  notAvailable: 'N/A',
  notOrdered: 'Not ordered',
  backorderQty: 'Backorder: {{qty}}',
  orderStatus: {
    draft: 'Draft',
    pending: 'Pending',
    ordered: 'Ordered',
    partial: 'Partially delivered',
  },
  addStockModalTitle: 'Add Stock',
  searchPartPlaceholder: 'Search for a part...',
  quantityToAdd: 'Quantity to Add (use - to reduce, e.g. -3)',
  enterQuantity: 'Enter quantity',
  restockNotesPlaceholder: 'Notes about this restock...',
  adjustStockModalTitle: 'Adjust Stock',
  selectOrSearchPart: 'Select or search part...',
  newQuantity: 'New Quantity',
  enterNewQuantity: 'Enter new quantity',
  reason: 'Reason',
  reasonPlaceholder: 'Reason for adjustment...',
  failedToAddStock: 'Failed to add stock: {{error}}',
  failedToAdjustStock: 'Failed to adjust stock: {{error}}',
};

const de = {
  title: 'Lagerverwaltung',
  subtitle: 'Lagerbestände überwachen und verwalten',
  adjustStockButton: 'Bestand anpassen',
  addStockButton: '+ Bestand hinzufügen',
  totalMovements: 'Bewegungen gesamt',
  stockIn: 'Wareneingang',
  stockOut: 'Warenausgang',
  lowStock: 'Niedriger Bestand',
  outOfStock: 'Nicht auf Lager',
  movementsTab: 'Bewegungen ({{count}})',
  stockLevelsTab: 'Lagerbestände ({{count}})',
  lowStockAlertsTab: 'Niedrigbestand-Warnungen',
  searching: 'Suche: „{{term}}“',
  supplier: 'Lieferant:',
  allStatus: 'Alle Status',
  inStock: 'Auf Lager',
  clear: 'Zurücksetzen',
  noMovementsTitle: 'Keine Lagerbewegungen',
  noMovementsMessage: 'Bewegungen werden hier angezeigt, sobald Sie den Bestand verwalten',
  part: 'Teil',
  type: 'Typ',
  qty: 'Menge',
  currentStock: 'Aktueller Bestand',
  daysUntilEmpty: 'Tage bis leer',
  reference: 'Referenz',
  supplierHeader: 'Lieferant',
  user: 'Benutzer',
  noStockLevelsTitle: 'Keine Lagerbestände',
  noStockLevelsMessage: 'Fügen Sie Teile hinzu, um Lagerbestände zu sehen',
  orderNumber: 'Offene Bestellung',
  quantity: 'Menge',
  minLevel: 'Mindestbestand',
  restockingNotes: 'Wiederauffüllung {{name}}',
  add: 'Hinzufügen',
  adjust: 'Anpassen',
  noAlertsTitle: 'Keine Niedrigbestand-Warnungen',
  noAlertsMessage: 'Alle Artikel sind ausreichend bevorratet',
  current: 'Aktuell',
  orderNr: 'Offene Bestellung',
  daysUntilEmptyHeader: 'Tage bis leer',
  notAvailable: 'k. A.',
  notOrdered: 'Nicht bestellt',
  backorderQty: 'Rückstand: {{qty}}',
  orderStatus: {
    draft: 'Entwurf',
    pending: 'Ausstehend',
    ordered: 'Bestellt',
    partial: 'Teilweise geliefert',
  },
  addStockModalTitle: 'Bestand hinzufügen',
  searchPartPlaceholder: 'Nach einem Teil suchen...',
  quantityToAdd: 'Hinzuzufügende Menge (mit - reduzieren, z.B. -3)',
  enterQuantity: 'Menge eingeben',
  restockNotesPlaceholder: 'Notizen zu dieser Wiederauffüllung...',
  adjustStockModalTitle: 'Bestand anpassen',
  selectOrSearchPart: 'Teil auswählen oder suchen...',
  newQuantity: 'Neue Menge',
  enterNewQuantity: 'Neue Menge eingeben',
  reason: 'Grund',
  reasonPlaceholder: 'Grund für die Anpassung...',
  failedToAddStock: 'Bestand konnte nicht hinzugefügt werden: {{error}}',
  failedToAdjustStock: 'Bestand konnte nicht angepasst werden: {{error}}',
};

const stockMovements = { en, de };
export default stockMovements;
